import CircularProgress from '@mui/material/CircularProgress';

interface IProps {
  type: "submit" | "reset" | "button";
  value: string | JSX.Element;
  width?: string;
  sx?: any;
  onClick?: () => void;
  disabled?:boolean
  isLoading?:boolean
}

const ButtonComponent = (props: IProps) => {
  const { type, value, width = "fit-content", sx,disabled ,isLoading,...rest } = props;
  return (
    <button
      style={{
        width: width,
        height: "50px",
        borderRadius: "5px",
        backgroundColor: disabled?"grey":"#0060ff",
        padding: "10px 30px",
        color: "#fff",
        fontWeight: 600,
        fontSize: "15px",
        border: 0,
        outline: 0,
        cursor: disabled?'default':"pointer",
        ...sx,
      }}
      type={type}
      disabled={disabled }
      {...rest}
    >
      { isLoading ? <CircularProgress sx={{height:'30px',width:"30px"}}/> :value}
    </button>
  );
};

export default ButtonComponent;
